import { useState, useRef } from "react";
import { Form, Spinner } from "react-bootstrap";
import { authenticationService } from "../services/authentication.service";

export default function ConfirmationPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const passwordRef = useRef<HTMLInputElement>(null);

    const handleSubmit = (event: React.FormEvent) => {
        if (loading === false) {
            authenticationService.login(username, password).then(
                (user) => {
                    window.location.href = "/";
                },
                (error) => {
                    setLoading(false);
                    setError(JSON.stringify(error));
                }
            );
            setLoading(true);
        }
        event.preventDefault();
        return false;
    };

    return (
        <div className="loading auth-fluid-pages pb-0">
            <div className="auth-fluid">
                <div className="auth-fluid-right">
                    <div className="auth-user-testimonial">
                        <h3 className="mb-3 text-white">
                            EFILEMADEEASY IS AN INCREDIBLY EASY EFILE SERVICE.
                        </h3>
                        <p className="lead fw-normal">
                            <i className="mdi mdi-format-quote-open"></i>{" "}
                            eFileMadeEasy is a unique, one of a kind service,
                            that eFiles with the Florida E-Portal and eServes
                            your service list with the required service by
                            email. With a few mouse clicks your document is
                            completely prepared, filed and served. No more back
                            and forth between programs, selecting files,
                            scanning documents multiple times, typing in email
                            addresses, and the other time wasting steps required
                            to eFile. Save time, reduce mistakes, and do what
                            you do best practice law.
                            <i className="mdi mdi-format-quote-close"></i>
                        </p>
                        <h5 className="text-white">- eFileMadeEasy</h5>
                    </div>
                </div>
                <div className="auth-fluid-form-box">
                    <div className="align-items-center d-flex h-100">
                        <div className="card-body">
                            <div className="auth-brand text-center text-lg-start">
                                <div className="auth-logo">
                                    <a
                                        href="index.html"
                                        className="logo logo-dark text-center"
                                    >
                                        <span className="logo-lg">
                                            <img
                                                width="256"
                                                src="https://www.efilemadeeasy.com/wp-content/uploads/2019/06/headlogo.png"
                                                alt="eFileMadeEasy"
                                            />
                                        </span>
                                    </a>
                                    <a
                                        href="index.html"
                                        className="logo logo-light text-center"
                                    >
                                        <span className="logo-lg">
                                            <img
                                                src="../assets/images/logo-light.png"
                                                alt=""
                                                height="22"
                                            />
                                        </span>
                                    </a>
                                </div>
                            </div>
                            <h4 className="mt-0">Registration Successful!</h4>
                            <p className="text-muted mb-4">
                                Please login below with your username and
                                password.
                            </p>
                            <Form action="#" onSubmit={handleSubmit}>
                                <div className="mb-2">
                                    <label
                                        htmlFor="username"
                                        className="form-label"
                                    >
                                        Username
                                    </label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        id="username"
                                        required={true}
                                        placeholder="Enter your username"
                                        onChange={(event: React.FormEvent) => {
                                            const usernameInput =
                                                event.currentTarget as HTMLInputElement;
                                            setUsername(usernameInput.value);
                                        }}
                                    />
                                </div>
                                <div className="mb-2">
                                    <a
                                        href="#"
                                        className="text-muted float-end"
                                    >
                                        <small>Forgot your password?</small>
                                    </a>
                                    <label
                                        htmlFor="password"
                                        className="form-label"
                                    >
                                        Password
                                    </label>
                                    <div className="input-group input-group-merge">
                                        <input
                                            ref={passwordRef}
                                            type="password"
                                            id="password"
                                            className="form-control"
                                            placeholder="Enter your password"
                                            onChange={(
                                                event: React.FormEvent
                                            ) => {
                                                const passwordInput =
                                                    event.currentTarget as HTMLInputElement;
                                                setPassword(
                                                    passwordInput.value
                                                );
                                            }}
                                        />
                                        <div
                                            className="input-group-text"
                                            data-password="false"
                                            onClick={() => {
                                                if (
                                                    passwordRef.current!
                                                        .type === "password"
                                                )
                                                    passwordRef.current!.type =
                                                        "text";
                                                else {
                                                    passwordRef.current!.type =
                                                        "password";
                                                }
                                            }}
                                        >
                                            <span className="password-eye"></span>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-grid text-center">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                    >
                                        {loading && (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                                &nbsp; Loading...
                                            </>
                                        )}
                                        {!loading && <>Log In</>}
                                    </button>
                                </div>
                                <div className="d-grid text-center">
                                    {error}
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
